import React, { useMemo } from "react";
import { useTranslation, Trans } from "react-i18next";
import img1 from "assets/images/users/1.jpg";
import { Button } from 'reactstrap';
import { Link } from "react-router-dom";
import { PayrollClient } from "services";
import { NotificationManager } from "react-notifications";
import { GenericTable } from "./GenericTable";

export const MonthlyTable = ({ t, fetch, setSelectedRows, setRefetchTrigger, refetch }) => {

    const payroll = PayrollClient();

    const update_status = (row, status, _index) => {
        payroll.post(`monthly_attendance_status`, {
            period: row.start_date, employee: row.employee_data.id, status, delay: row.delay, total: row.total, fixed: row.fixed
        }).get('data').then((response) => {
            setRefetchTrigger(prev => !prev)
            NotificationManager.success(t('Updated Successfully'));
        }).catch(error => {
            NotificationManager.error(t('Error while updating'));
        });
    }

    const columns = useMemo(
        () =>
            [
                {
                    Header: t("Employee"),
                    accessor: "employee_data.full_name",
                    Cell: ({ value, row: { original } }) => (
                        <div className="row text-left w-100">
                            <div className="row pl-3 w-100">
                                <div className="col-2">
                                    <img src={original.employee_data.employee_picture || img1} width="29" />
                                </div>
                                <div className="col-10">
                                    <Link to={`/payroll/employees/${original.employee_data.id}`}>
                                        {value}
                                    </Link>
                                </div>
                            </div>

                        </div>
                    ),

                },
                {
                    Header: t("Start Date"),
                    accessor: "start_date",
                    Cell: ({ value, row: { original } }) => (
                        <div style={{ textWrap: "nowrap" }}>
                            {value}
                        </div>
                    ),
                },

                {
                    Header: t("End Date"),
                    accessor: "end_date",
                    Cell: ({ value, row: { original } }) => (
                        <div style={{ textWrap: "nowrap" }}>
                            {value}
                        </div>
                    ),
                },

                {
                    Header: t("Total Monthly"),
                    accessor: "total",
                },

                {
                    Header: t("Fixed Monthly"),
                    accessor: "fixed",
                },
                {
                    Header: t("Difference Monthly"),
                    accessor: "delay",
                },
                {
                    Header: t("Result"),
                    accessor: "chart_account",
                },
                {
                    Header: t("Action"),
                    accessor: "status",
                    Cell: ({ value, row: { original, index } }) => {
                        return (
                            original.delay ?
                                <>
                                    {!value ?
                                        <div className="d-flex justify-content-center">
                                            <Button color="success" className="mx-1 my-0" onClick={() => update_status(original, "Approved", index)}><Trans>Accept {value}</Trans></Button>
                                            <Button color="danger" className="mx-1 my-0" onClick={() => update_status(original, "Rejected", index)}><Trans>Reject </Trans></Button>
                                        </div>
                                        :
                                        <div className={`px-2 py-1 rounded d-inline-block border ${value === "Approved" ? "border-success text-success" : "border-danger text-danger"}`}>
                                            <Trans>{value}</Trans>
                                        </div>
                                    }
                                </> :
                                "-"
                        );
                    }
                },

            ]
    );

    return (
        <GenericTable columns={columns} fetch={fetch} reload={false} queryParams={['monthly_attendance', refetch]} setSelectedRows={setSelectedRows} refetch={refetch} />
    );
};
